






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {Endereco} from '@/model/resource/Endereco'
import {InputEnderecoSchema} from '@/schema/resource/Endereco/InputEnderecoSchema'

@Component
export default class PersistEnderecoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputEnderecoSchema()
  endereco = new Endereco()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.endereco.getEndereco(id)
    }

    $.await.done('getEndereco')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.endereco.persistEndereco()
    await Helper.successAndPush('system.success.persist', '/endereco/list')
  }
}
